
 (function(){
    function onReady(fn){ 
        if (document.readyState === 'loading') 
            document.addEventListener('DOMContentLoaded', fn); 
        else 
            fn(); 
    }

    // Mobile-only: enforce one-tile-per-swipe for the snap carousel
    function initMobileSnapCarousels() {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        var containers = document.querySelectorAll('.carousel--root[data-mobile-snap="true"] .carousel--container');
        containers.forEach(function (el) {
            // Avoid double-binding
            if (el.__snapBound) return;
            el.__snapBound = true;

            var startX = 0;
            var startScroll = 0;
            var startTime = 0;
            var touching = false;
            var settleTimer = null;

            function getSlides() {
                return Array.prototype.slice.call(el.querySelectorAll(':scope > .carousel--block'));
            }

            function getOffsets() {
                var slides = getSlides();
                return slides.map(function (s) { return s.offsetLeft; });
            }

            function nearestIndex(left) {
                var offs = getOffsets();
                // Compensate for container left padding so we keep the gutter visible
                var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
                var leftAdj = left + pad;
                if (offs.length === 0) return 0;
                var idx = 0;
                var minD = Infinity;
                for (var i = 0; i < offs.length; i++) {
                    var d = Math.abs(offs[i] - leftAdj);
                    if (d < minD) { minD = d; idx = i; }
                }
                return idx;
            }

            el.addEventListener('touchstart', function (e) {
                touching = true;
                startX = e.touches[0].clientX;
                startScroll = el.scrollLeft;
                startTime = e.timeStamp || Date.now();
            }, { passive: true });

            el.addEventListener('touchend', function (e) {
                if (!touching) return;
                touching = false;
                var endX = (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startX);
                var dx = endX - startX; // + right, - left
                var dt = (e.timeStamp || Date.now()) - startTime;
                var slides = getSlides();
                var offsets = getOffsets();
                var firstSlide = slides[0];
                var slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : Math.max(window.innerWidth, 1);

                var currentIndex = nearestIndex(el.scrollLeft);
                var velocity = Math.abs(dx) / Math.max(dt, 1); // px per ms
                var distanceThreshold = Math.max(40, slideWidth * 0.12); // 12% swipe or 40px
                var velocityThreshold = 0.4; // quick flick

                if (Math.abs(dx) > distanceThreshold || velocity > velocityThreshold) {
                    if (dx < 0) currentIndex += 1; // swipe left -> next
                    if (dx > 0) currentIndex -= 1; // swipe right -> prev
                }

                // Clamp
                var maxIndex = Math.max(slides.length - 1, 0);
                currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

                // Snap keeping the left gutter visible
                var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
                var targetLeft = (offsets[currentIndex] != null ? offsets[currentIndex] - pad : currentIndex * slideWidth);
                el.scrollTo({ left: Math.max(targetLeft, 0), behavior: 'smooth' });
            }, { passive: true });

            // Momentum-end settle: snap to nearest when scrolling stops
            el.addEventListener('scroll', function () {
                if (touching) return; // let touchend handler decide
                clearTimeout(settleTimer);
                settleTimer = setTimeout(function () {
                    var idx = nearestIndex(el.scrollLeft);
                    var offs = getOffsets();
                    var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
                    var target = (offs[idx] != null ? offs[idx] - pad : 0);
                    el.scrollTo({ left: Math.max(target, 0), behavior: 'smooth' });
                }, 120);
            }, { passive: true });
        });
    }
    onReady(function(){
        // Initialize on ready and on resize/orientation change (debounced)
        initMobileSnapCarousels();
        var snapTimer;
        window.addEventListener('resize', function () {
            clearTimeout(snapTimer);
            snapTimer = setTimeout(initMobileSnapCarousels, 200);
        });
        window.addEventListener('orientationchange', function () {
            clearTimeout(snapTimer);
            snapTimer = setTimeout(initMobileSnapCarousels, 200);
        });
    });
})();
